import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import DescriptionIcon from '@mui/icons-material/Description';
import InventoryIcon from "@mui/icons-material/Inventory";

const SidebarData = (accessLevel) => {
    const commonItems = [
        {
            title: "Dashboard",
            path: "/dashboard",
            icon: <DashboardIcon />,
        },
        {
            title: "Boardroom Reservations",
            path: "/schedules",
            icon: <CalendarMonthIcon />,
        },
        {
            title: "IT Equipment Reservations",
            path: "/equipments",
            icon: <InventoryIcon />,
        },
    ];

    if (accessLevel === "ADMIN") {
        return [
            ...commonItems,
            {
                title: "Available Boardrooms List",
                path: "/assembly-hall",
                icon: <MeetingRoomIcon />,
            },
            {
                title: "Boardroom Reservation Report",
                path: "/boardroom-reservation-report",
                icon: <DescriptionIcon />,
            },
 
        ];
    } else if (accessLevel === "IT_HELPDESK") {
        return [
            ...commonItems,
            {
                title: "Equipment Reservation Report",
                path: "/equipment-reservation-report",
                icon: <DescriptionIcon />,
            },
 
        ];
    }

    return commonItems;
};

export default SidebarData;
